import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from 'components/shadcn/ui/dialog';
import { Button } from 'components/shadcn/ui/button';

const DetachSiteConfirmation = ({ open, close, confirm }) => {
    return (
        <Dialog
            open={open}
            onOpenChange={close}
            className='flex items-center justify-center z-50'
            aria-labelledby="detach-site-confirmation-title"
        >
            <DialogContent className='max-w-sm'>
                <DialogHeader>
                    <DialogTitle>
                        Are you sure you want to detach site from this device?
                    </DialogTitle>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        type="button"
                        variant="outline"
                        onClick={close}
                    >
                        no
                    </Button>
                    <Button
                        type="button"
                        variant="destructive"
                        onClick={confirm}
                    >
                        yes
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default DetachSiteConfirmation;
